import React from 'react';
import { ringBorder, C } from '../portalkit';
import { ORDER, STEP_LABELS, isDone } from './plannerModel';
import { normalizeSkip } from './plannerSkips';

export const STAGES = ORDER.map((key, i) => ({ key, label: STEP_LABELS[i] }));

/**
 * The step rail — eight pills in a black capsule (design_handoff_auth_profile_planner §5).
 * Done: white with a green check. Current: #161616 inside the ring, a pulsing pink dot. Future:
 * #6B6B6B. Skipped: struck through in #4A4A4A, no check. Scrolls sideways on a phone.
 * `step` is the beat on screen (1‥8); `ready` closes every beat.
 */
export default function PlannerStepper({ stages = {}, skip, step = 1, ready = false, posterLocked = false }) {
  const sk = normalizeSkip(skip);
  return (
    <div role="list" aria-label="Planning stages" className="pk-scroll-x" style={{ display: 'flex', gap: 6, padding: 4, borderRadius: 999, background: '#000' }}>
      {STAGES.map((s, i) => {
        const n = i + 1;
        const skipped = !!sk[s.key];
        const done = !skipped && (ready || step > n || (s.key !== 'poster' && isDone(stages, sk, s.key) && step > n));
        const active = !skipped && !ready && step === n;
        const lock = s.key === 'poster' && !done && !skipped && posterLocked && !ready;
        return (
          <div
            key={s.key}
            role="listitem"
            aria-current={active ? 'step' : undefined}
            data-done={done ? 'true' : undefined}
            data-skipped={skipped ? 'true' : undefined}
            title={skipped ? 'Skipped' : lock ? 'Drawn when you approve' : s.label}
            style={{ flex: '1 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, height: 36, padding: '0 14px', border: '2px solid transparent', borderRadius: 999, boxSizing: 'border-box', whiteSpace: 'nowrap', background: active ? ringBorder('#161616') : 'transparent', color: skipped ? '#4A4A4A' : done || active ? '#fff' : C.onBlack4, fontSize: 10, fontWeight: 700, letterSpacing: '.14em', textDecoration: skipped ? 'line-through' : 'none', transition: 'color .2s' }}
          >
            {done && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="3.5" strokeLinecap="square" aria-hidden="true"><path d="M4 12l5 5L20 6" /></svg>}
            {active && <span data-motion="1" className="pk-pulse-fast" aria-hidden="true" style={{ width: 7, height: 7, borderRadius: '50%', background: C.pink }} />}
            {s.label}
          </div>
        );
      })}
    </div>
  );
}
